import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useThemePreference } from '../../context/ThemePreferenceContext';

const AppThemeProvider = ({ children }) => {
  const { theme } = useThemePreference();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
